Vue.component('classdescription', {
    template: `
        <div>

            <div id="descriptionTooltip" class="col-6 cpcDesc" v-bind:style="position" :class="[{'show' : showDesc}, align]">

                <div class="d-flex justify-content-between descTitle">
                    <b>
                        {{ currentClass }}
                    </b>
                    <span @click="showDesc = false" class="closeDesc">
                        &times;
                    </span>
                </div>

                <div class="cpcDescription">
                    <div class="row" v-for="description in classes[currentClass]">
                        <div class="col-xl-3 col-4" :class="'indent-' + description.indent">
                            <b>
                                {{ description.symbol }}
                            </b>
                        </div>
                        <div class="col-xl-9 col-8" :class="'dot-' + description.dots">
                            <read-more :text="description.text"></read-more>
                        </div>
                    </div>
                </div>

                <div class="arrow"></div>
            </div>
        </div>
    `,

    data: function() {
        return {
            classes: {},
            currentClass: '',
            showDesc: false,
            top: null,
            bottom: null,
            left: null,
            align: ''
        };
    },

    props: ['system'],

    computed: {
        position() {
            if (this.top) {
                return {
                    top: this.top,
                    left: this.left
                }
            } else if (this.bottom) {
                return {
                    bottom: this.bottom,
                    left: this.left
                }
            }
        }
    },

    mounted: function() {
        EventBus.$on('new_class', (description, className, target) => {

            this.currentClass = className;
            this.classes[className] = description;

            this.setPosition(target);

            this.showDesc = true;

        });

        EventBus.$on('closeDescription', () => {

            this.showDesc = false

        })

    },

    methods: {

        setPosition(target) {

            let targetPosition = target.getBoundingClientRect();
            let scroll = document.getElementById('technologies').scrollTop;
            let mainPosition = document.getElementById('technologies').getBoundingClientRect();

            let ratio = (targetPosition.top - mainPosition.top) / mainPosition.height;

            this.left = 'calc(' + (targetPosition.left - mainPosition.left + targetPosition.width) + 'px + 1.5rem)';

            if (ratio <= 1 / 3) {
                this.bottom = null;
                this.top = (targetPosition.top + scroll - mainPosition.top) + 'px';
                this.align = 'top';
            } else if (1 / 3 < ratio && ratio <= 2 / 3) {
                this.bottom = null;
                this.top = (targetPosition.top + scroll - mainPosition.top) + 'px';
                this.align = 'middle';
            } else if (2 / 3 < ratio) {
                this.top = null;
                this.bottom = (mainPosition.height - targetPosition.top - scroll + mainPosition.top - 30) + 'px';
                this.align = 'bottom';
            }
        }
    }
});
